<template>
    <cr-app id="app">
        <div class="loading-wrapper">
            <cr-loading />
        </div>
    </cr-app>
</template>

<style scoped>
.loading-wrapper {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
